import { useRef } from "react";
function useId(prefix = "id") {
    const idRef = useRef(null);
    if (idRef.current === null) {
        idRef.current = `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
    }
    return idRef.current;
}
export default useId;
